// import 'complaint-confirmation.js';
import 'complaint-form.js';
import 'signature-pad.js';
import 'address-search.js';
import 'lawyer_search.js';
import 'text_area_counter.js';
import 'complaint-step2-validation.js';
import 'trim-spaces.js';

import '../src/styles/main';
